import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {LoginService} from '../login.service';
import * as CryptoJS from 'crypto-js';
import { DatePipe } from '@angular/common';
import { sha256, sha224 } from 'js-sha256';
import { ServerConstantsService } from '../serverConstants.service';

@Component({
  selector: 'app-clientsummary',
  templateUrl: './clientsummary.component.html',
  styleUrls: ['./clientsummary.component.css']
})
export class ClientsummaryComponent implements OnInit { 
  visible:Boolean = false;
  firstName:any;
  lastName:any;
  gender:any;
  ssn:any;
  primaryLanguage:any;
  dob:any;
  resedentialPhone:any;
  messagePhone:any;
  workPhone:any;
  residentialaddr1:any;
  residentialaddr2:any;
  residentialCity:any;
  residentialState:any;
  residentialZip:any;
  residentialCounty:any;
  mailingaddr1:any;
  mailingaddr2:any;
  mailingCity:any;
  mailingState:any;
  mailingZip:any;
  additionalContact:any =  null;
  additionalEmail:any;
  additionalPrimary:any;
  additionalSecondary:any;
  additionalMessage:any;

  constructor(public loginService:LoginService, public toastService:ToastrService, private datePipe: DatePipe){}

  ngOnInit() {
    this.getUserInfo(this.loginService.personId);
  }
  toggle(){
    this.visible = !this.visible;
  }
  getUserInfo(id){
    this.loginService.getuser(id).subscribe((data)=>{
      if(data["id"]){
        this.loginService.personId = data["id"];
        let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
        sessionStorage.setItem('id',CryptoJS.AES.encrypt(data["id"].toString(),key).toString());
        this.loginService.firstName = data["firstName"];
        sessionStorage.setItem("firstName",CryptoJS.AES.encrypt(data["firstName"].toString(),key).toString());
        this.loginService.lastName = data["lastName"];
        sessionStorage.setItem("lastName",CryptoJS.AES.encrypt(data["firstName"].toString(),key).toString());
        this.loadInformation(data["emciId"]);
      }
      else{
        this.toastService.error("Unable to load User Information","My Information");
      }
    },error=>{
      this.toastService.error("Unable to load User Information","My Information");
    })
  }
  getcitizenInfo(ssn){
    let request = {
      "ssn":ssn
    }
    this.loginService.getClientinfo(request).subscribe((data:Array<Object>)=>{
      if(data[0]["CLIENTID"]){
        if(data[0]["BENEFIT"] == null){
          this.loginService.monthlyBenefit = 0;
        }
        else{
          let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
          this.loginService.monthlyBenefit = data[0]["BENEFIT"];
          sessionStorage.setItem('benefit',CryptoJS.AES.encrypt(data[0]["BENEFIT"].toString(),key).toString());
        }
        this.loginService.participationCode = data.find(obj => obj['HH_MEM_RELATIONSHIP'] == 'Self')['HH_MEM_WP'];
        //this.loginService.maxWage=Math.max.apply(Math, this.loginService.staticData.get("Maxwages").map(function(o) { return o.value; }));
        this.firstName=data[0]["FIRST_NAME"];
        this.lastName=data[0]["LAST_NAME"];
        if(data[0]["GENDER_CD"] == 'M'){
          this.gender= 'Male';
        }
        else{
          this.gender = 'Female';
        }
        this.ssn=data[0]["SSN"];
        this.primaryLanguage=data[0]["PRIMARY_LANGUAGE"];
        // Ticket 49102 - Start - Fixing the format to DOB Date
        let dobDt = data[0]["DOB_DT"].split(' ')[0];
        this.dob= this.datePipe.transform(dobDt, 'MM/dd/yyyy');
        // Ticket 49102 - End - Fixing the format to DOB Date
        this.resedentialPhone=data[0]["RESIDENTIAL_PHONE"];
        // Ticket 49102 -Start- Fixing the format to drop the extensions
        let msgPhone = data[0]["MESSAGE_PHONE"];
        if(msgPhone != null){
          this.messagePhone=msgPhone.substr(0,12);
        }// Ticket 49102 -End- Fixing the format to drop the extensions
        this.workPhone=data[0]["WORK_PHONE"];
        this.residentialaddr1=data[0]["RESIDENTIAL_ADDR_LINE1"];
        this.residentialaddr2=data[0]["RESIDENTIAL_ADDR_LINE2"];
        this.residentialCity=data[0]["RESIDENTIAL_ADDR_CITY"];
        this.residentialState=data[0]["RESIDENTIAL_ADDR_STATE"];
        this.residentialZip=data[0]["RESIDENTIAL_ADDR_ZIP"];
        this.residentialCounty=data[0]["RESIDENTIAL_COUNTY"];
        this.mailingaddr1=data[0]["MAILING_ADDR_LINE1"];
        this.mailingaddr2=data[0]["MAILING_ADDR_LINE2"];
        this.mailingCity=data[0]["MAILING_ADDR_CITY"];
        this.mailingState=data[0]["MAILING_ADDR_STATE"];
        this.mailingZip= data[0]["MAILING_ADDR_ZIP"];
      }
      else{
        this.toastService.error("Unable to load User Information","My Information");
      }
    },error=>{
      this.toastService.error("Unable to load User Information","My Information");
    })
  }
  loadInformation(emciId){
    let request = {
      userId:this.loginService.personId
    }
    this.loginService.getInformation(request).subscribe((data)=>{
      let information = data[0];
       if(information["id"]){
        this.firstName=information.first_name;
        this.lastName=information.last_name;
        this.gender = this.format(information.gender_cd,'M','Male','Female');
        this.ssn=information.ssn;
        this.primaryLanguage=this.format(information.primary_language,'EN','English','Spanish');
        this.dob= this.datePipe.transform(information.dob_dt, 'MM/dd/yyyy');
        // Ticket 49102 - End - Fixing the format to DOB Date
        this.resedentialPhone=information.residential_phone;
        // Ticket 49102 -Start- Fixing the format to drop the extensions

          this.messagePhone=information.message_phone;
        // Ticket 49102 -End- Fixing the format to drop the extensions
        this.workPhone=information.work_phone;
        this.residentialaddr1=information.residential_addr_line1;
        this.residentialaddr2=information.residential_addr_line2;
        this.residentialCity=information.residential_addr_city;
        this.residentialState=information.residential_addr_state;
        this.residentialZip=information.residential_addr_zip_5;
        this.residentialCounty=information.residential_county;
        this.mailingaddr1=information.mailing_addr_line1;
        this.mailingaddr2=information.mailing_addr_line2;
        this.mailingCity=information.mailing_addr_city;
        this.mailingState=information.mailing_addr_state;
        this.mailingZip= information.mailing_addr_zip_5;
        if(information.contact_method != null){
          this.additionalContact = this.loginService.staticData.get("ContactMethod").find(obj => obj.value == information.contact_method).name;
        }
        this.additionalEmail = information.email;
        this.additionalPrimary = this.format(information.primary_language,'EN','English','Spanish');
        this.additionalSecondary = this.format(information.secondary_language,'EN','English','Spanish');
        this.additionalMessage = this.format(information.text_message_sw,'Y','Yes','No');
        let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
        CryptoJS.AES.decrypt(sessionStorage.getItem('conversion_stat'), key).toString(CryptoJS.enc.Utf8) === 'true' ?  
        this.getAriesCitizenInfo(emciId) :this.getcitizenInfo(information.ssn);
        //this.getcitizenInfo(information.ssn);
       }
       else{
        this.toastService.error("Unable to load User Information","My Information");
       }
    },error=>{
      this.toastService.error("Unable to load User Information","My Information");
    })
  }

  getAriesCitizenInfo(value){
    let request = {
      "type":"clientInfo",
      "value":value+"/null"
    }
    this.loginService.getClietinfoAries(request).subscribe((data:Array<Object>)=>{
      if(data[0]["indvId"]){
        //if(data[0]["BENEFIT"] == null){
          this.loginService.monthlyBenefit = 0;
        /*}
        else{
          let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
          this.loginService.monthlyBenefit = data[0]["BENEFIT"];
          sessionStorage.setItem('benefit',CryptoJS.AES.encrypt(data[0]["BENEFIT"].toString(),key).toString());
        }*/
        //this.loginService.participationCode = data.find(obj => obj['HH_MEM_RELATIONSHIP'] == 'Self')['HH_MEM_WP'];
        this.loginService.participationCode = "Mandatory - SNAP";
        //this.loginService.maxWage=Math.max.apply(Math, this.loginService.staticData.get("Maxwages").map(function(o) { return o.value; }));
        this.firstName=data[0]["firstName"];
        this.lastName=data[0]["lastName"];
        if(data[0]["genderCd"] == 'M'){
          this.gender= 'Male';
        }
        else{
          this.gender = 'Female';
        }
        this.ssn=data[0]["ssn"];
        let dobDt = new Date(data[0]["dobDt"]);
        this.dob= this.datePipe.transform(dobDt, 'MM/dd/yyyy');
        // Ticket 49102 - End - Fixing the format to DOB Date
        this.resedentialPhone=data[0]["altPhnNum"];
        // Ticket 49102 -Start- Fixing the format to drop the extensions
        this.messagePhone = data[0]["primaryPhnNum"];
        //if(msgPhone != null){
          //this.messagePhone=msgPhone.substr(0,12);
        //}// Ticket 49102 -End- Fixing the format to drop the extensions
        this.workPhone=data[0]["workPhnNum"];
        this.primaryLanguage = data[0]["primaryLang"];
        if(data[0]["address"].find(obj => obj['addrTypeCd'] == 'PA') !== undefined){
          let address = data[0]["address"].find(obj => obj['addrTypeCd'] == 'PA');
          this.residentialaddr1=address["addrLine1"];
          this.residentialaddr2=address["addrLine2"];
          this.residentialCity=address["addrCity"];
          this.residentialState=address["addrStateCd"];
          this.residentialZip=address["addrZip5"];
        }
        if(data[0]["address"].find(obj => obj['addrTypeCd'] == 'MA') !== undefined){
          let address = data[0]["address"].find(obj => obj['addrTypeCd'] == 'MA');
          //address["addrCountyCd"] !== null ? this.residentialCounty=address["addrCountyCd"] : this.residentialCounty=this.residentialCounty;
          this.mailingaddr1=address["addrLine1"];
          this.mailingaddr2=address["addrLine2"];
          this.mailingCity=address["addrCity"];
          this.mailingState=address["addrStateCd"];
          this.mailingZip=address["addrZip5"];
        }
        
        /*this.mailingaddr1=data[0]["MAILING_ADDR_LINE1"];
        this.mailingaddr2=data[0]["MAILING_ADDR_LINE2"];
        this.mailingCity=data[0]["MAILING_ADDR_CITY"];
        this.mailingState=data[0]["MAILING_ADDR_STATE"];
        this.mailingZip= data[0]["MAILING_ADDR_ZIP"];*/
        //this.primaryLanguage=data[0]["PRIMARY_LANGUAGE"];
        // Ticket 49102 - Start - Fixing the format to DOB Date
        
      }
      else{
        this.toastService.error("Unable to load User Information","My Information");
      }
    },error=>{
      this.toastService.error("Unable to load User Information","My Information");
    })
  }


  format(value1,value2,value3,value4){
    if(value1 == null){
      return null;
    }
    else if(value1 == value2){
      return value3;
    }
    else{
      return value4;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/clientsummary/clientsummary.component.ts